import { Component, OnInit } from '@angular/core';
import templateString from './templatePeriodAccumulationTypes.component.html';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../../environment.service';
import { takeUntil } from 'rxjs/operators';
import { TemplatePeriodAccumulationTypeFormComponent } from '../templatePeriodAccumulationTypeForm';
import { TemplatePeriodAccumulationTypeChangeOrderComponent } from '../templatePeriodAccumulationTypeChangeOrder';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class TemplatePeriodAccumulationTypesComponent implements OnInit {
    
    public templatePeriodAccumulationTypes: any;
    public selectedSchedulePeriod: any;
    public destroyed$: any;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private bsModalService: BsModalService,
        private environmentService: EnvironmentService
	) { 
        this.destroyed$ = new Subject<boolean>();
    }

    refresh() {
        this.http.get("template_period_accumulation_types", { params: { schedule_period_id: this.selectedSchedulePeriod.id } }).subscribe(x => {
            this.templatePeriodAccumulationTypes = x;
        });
    }
    
    changeSchedulePeriod() {
        this.refresh();
    }

    create() {
        var bsModalRef = this.bsModalService.show(TemplatePeriodAccumulationTypeFormComponent, {
            initialState: {
                templatePeriodAccumulationTypeId: null,
                schedulePeriodId: this.selectedSchedulePeriod.id
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(result => {	
			this.refresh();
        });
    }

    edit(templatePeriodAccumulationTypeId) {
        var bsModalRef = this.bsModalService.show(TemplatePeriodAccumulationTypeFormComponent, {
            initialState: {
                templatePeriodAccumulationTypeId: templatePeriodAccumulationTypeId,
                schedulePeriodId: this.selectedSchedulePeriod.id
            },
            class: 'modal-lg'
        });

        bsModalRef.content.action.subscribe(result => {	
			this.refresh();
        });
    }

    delete(templatePeriodAccumulationTypeId) {
        if (window.confirm('Weet je het zeker?')) {
            this.http.delete("template_period_accumulation_types/" + templatePeriodAccumulationTypeId).subscribe(() => {
				this.refresh();
			}, (response) => {
				this.toastr.error(response.error.error);
			});
        }
    };
    
    changeOrder() {
        var bsModalRef = this.bsModalService.show(TemplatePeriodAccumulationTypeChangeOrderComponent, {
            initialState: {
                originalTemplatePeriodAccumulationTypes: this.templatePeriodAccumulationTypes
            }
        });

        bsModalRef.content.action.subscribe(result => {	
			this.refresh();
        });
    }

    initialize() {
		this.selectedSchedulePeriod = this.environmentService.getSchedulePeriodSelection();

		this.refresh();
	}
	
    ngOnInit() {
        this.environmentService.selectedSchedulePeriodChanged$
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
                this.initialize();
            });

        this.initialize();
    }

    ngOnDestroy() {
		this.destroyed$.next();
		this.destroyed$.complete();
    }
}
